import React from "react";

const VideosTabs = ({ activeTab, handleChange, tabs }) => {
  return (
    <div className="wellnessVideoTabs">
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          {tabs.map((t, iDx) => (
            <div
              class={`nav-link ${activeTab === iDx ? `active` : ``}`}
              role="button"
              onClick={() => (activeTab === iDx ? {} : handleChange(iDx))}
            >
              {t.name}
            </div>
          ))}
        </div>
      </nav>
      <div id="nav-tabContent">{tabs?.[activeTab]?.component()}</div>
    </div>
  );
};

export default VideosTabs;
